import clsx from "clsx";

import { SecondaryButton } from "@components/v2/buttons";
import { IconButton } from "@shared/buttons";

import { useChannelComparisonModal } from "../hooks/use-channel-comparison-modal";
import { useSelectedChannels } from "../hooks/use-selected-channels";

export const ChannelComparisonButtons = ({
  className,
}: {
  className?: string;
}) => {
  const { selectedChannels, clearSelectedChannels, MAX_SELECTABLE_CHANNELS } =
    useSelectedChannels();
  const { setIsChannelComparisonModalOpen } = useChannelComparisonModal();

  return (
    <div className={clsx("space-x-3 flex", className)}>
      <div className="relative">
        <IconButton
          variant="primary"
          onClick={() => setIsChannelComparisonModalOpen(true)}
          disabled={selectedChannels.length === 0}
        >
          <div className="flex items-center font-semibold">
            <i className="fa-regular fa-shuffle inline-block mr-2" />
            COMPARE {`(${selectedChannels.length})`}
          </div>
        </IconButton>
        <div className="text-cosmic text-xs font-semibold absolute-horizontal-center whitespace-nowrap mt-1">
          Select up to {MAX_SELECTABLE_CHANNELS}
        </div>
      </div>
      <SecondaryButton
        className="h-8"
        onClick={clearSelectedChannels}
        disabled={selectedChannels.length === 0}
      >
        <div className="flex items-center font-semibold">
          <i className="fa-regular fa-square-minus inline-block mr-2 text-v2-action" />
          DESELECT ALL
        </div>
      </SecondaryButton>
    </div>
  );
};
